<template>
  <div class="wrap">
    <el-container direction="horizontal">
      <el-aside :width="isCollapse ? '80px' : '220px'">
        <SiderBar></SiderBar>
      </el-aside>
      <el-container>
        <el-header>
          <Header></Header>
        </el-header>
        <NavBar></NavBar>
        <el-main>
          <AppMain></AppMain>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SiderBar from './layout/SiderBar';
import Header from './layout/Header';
import NavBar from './layout/NavBar';
import AppMain from './layout/AppMain';

export default {
  name: 'Wrap',
  components: {
    SiderBar,
    Header,
    NavBar,
    AppMain,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      isCollapse: 'isCollapse',
    }),
  },
};
</script>

<style scoped lang="less">
  .wrap {
    background: #ecf0f5;
    overflow: hidden;
    height: 100%;
  }
  .el-container {
    height: 100vh;
  }
  .el-header {
    width: 100%;
    height: 60px !important;
    background-color: #27576d;
    // box-shadow: 0 2px 4px 0 rgba(182,190,199,0.14);
  }
  .el-main {
    padding: 0;
    height: calc(~'100vh - 100px');
    overflow-y: auto;
  }
  .el-aside {
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue